var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("e-breadcrumbs"),
      _c(
        "div",
        { attrs: { id: "layerPop" } },
        [
          _c(
            "win-layer-pop",
            [
              _vm.customComponent
                ? _c(_vm.customComponent, {
                    tag: "component",
                    attrs: { detail: _vm.detail },
                    on: { close: _vm.closePoup },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("h1", { staticClass: "page_title" }, [
        _vm._v(_vm._s(_vm.$t("menu.MENU04.010"))),
      ]),
      _c("form", { attrs: { id: "frm" } }, [
        _c("div", { staticClass: "content_box pb15" }, [
          _c("table", { staticClass: "tbl_search" }, [
            _vm._m(0),
            _c("tbody", [
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$t("msg.SPEC030.043")))]),
                _c("td", { staticClass: "pr0" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.param.asDtKnd,
                          expression: "param.asDtKnd",
                        },
                      ],
                      staticClass: "wid150",
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.param,
                              "asDtKnd",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function ($event) {
                            return _vm.optionChange()
                          },
                        ],
                      },
                    },
                    [
                      _c("option", { attrs: { value: "RQ" } }, [
                        _vm._v("Request No"),
                      ]),
                      _c("option", { attrs: { value: "DT" } }, [
                        _vm._v("Request Date"),
                      ]),
                    ]
                  ),
                ]),
                _c("td", { attrs: { colspan: "4" } }, [
                  _vm.param.asDtKnd === "RQ"
                    ? _c("div", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.param.asReqNo1,
                              expression: "param.asReqNo1",
                              modifiers: { trim: true },
                            },
                          ],
                          staticClass: "wid150",
                          attrs: { type: "text" },
                          domProps: { value: _vm.param.asReqNo1 },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.param,
                                "asReqNo1",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm.param.asDtKnd === "DT"
                    ? _c(
                        "div",
                        [
                          _c("e-date-range-picker", {
                            attrs: {
                              id: "fromDtToDt",
                              sdate: _vm.dateFrom,
                              edate: _vm.dateTo,
                            },
                            on: { change: _vm.changeDateRange },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _c("td", { staticClass: "text_right" }, [
                  _c(
                    "a",
                    {
                      staticClass: "button blue sh",
                      on: {
                        click: function ($event) {
                          return _vm.searchData()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("msg.CMBA100.00120")))]
                  ),
                ]),
              ]),
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.validationDt,
                      expression: "validationDt",
                    },
                  ],
                  staticStyle: { height: "15px" },
                },
                [_c("td")]
              ),
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$t("msg.SPEC030.006")))]),
                _c(
                  "td",
                  { attrs: { colspan: "2" } },
                  [
                    _c("e-auto-complete-place", {
                      attrs: {
                        id: "polPol",
                        "ctr-cd": _vm.pol.ctrCd,
                        "plc-cd": _vm.pol.plcCd,
                        "is-char": true,
                        "is-char-alert": true,
                      },
                      on: { change: _vm.changePol },
                    }),
                  ],
                  1
                ),
                _c("th", [
                  _c("span", { staticClass: "ml20" }, [
                    _vm._v(_vm._s(_vm.$t("msg.SPEC030.007"))),
                  ]),
                ]),
                _c(
                  "td",
                  { attrs: { colspan: "2" } },
                  [
                    _c("e-auto-complete-place", {
                      attrs: {
                        id: "podPod",
                        "ctr-cd": _vm.pod.ctrCd,
                        "plc-cd": _vm.pod.plcCd,
                        "is-char": true,
                        "is-char-alert": true,
                      },
                      on: { change: _vm.changePod },
                    }),
                  ],
                  1
                ),
              ]),
              _c("tr", [
                _c("td", { staticClass: "pl0", attrs: { colspan: "6" } }, [
                  _c("div", [
                    _c("span", { staticClass: "ml10" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.param.apvStsCd,
                            expression: "param.apvStsCd",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "ch1",
                          name: "chk1",
                          value: "02",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.param.apvStsCd)
                            ? _vm._i(_vm.param.apvStsCd, "02") > -1
                            : _vm.param.apvStsCd,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.param.apvStsCd,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "02",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.param,
                                    "apvStsCd",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.param,
                                    "apvStsCd",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.param, "apvStsCd", $$c)
                            }
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "ch1" } }, [
                        _c("span"),
                        _vm._v(_vm._s(_vm.$t("msg.SPEC030.002"))),
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.param.apvStsCd,
                            expression: "param.apvStsCd",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "ch2",
                          name: "chk2",
                          value: "03",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.param.apvStsCd)
                            ? _vm._i(_vm.param.apvStsCd, "03") > -1
                            : _vm.param.apvStsCd,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.param.apvStsCd,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "03",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.param,
                                    "apvStsCd",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.param,
                                    "apvStsCd",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.param, "apvStsCd", $$c)
                            }
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "ch2" } }, [
                        _c("span"),
                        _vm._v(_vm._s(_vm.$t("msg.SPEC030.003"))),
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.param.apvStsCd,
                            expression: "param.apvStsCd",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "ch3",
                          name: "chk3",
                          value: "01,04",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.param.apvStsCd)
                            ? _vm._i(_vm.param.apvStsCd, "01,04") > -1
                            : _vm.param.apvStsCd,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.param.apvStsCd,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "01,04",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.param,
                                    "apvStsCd",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.param,
                                    "apvStsCd",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.param, "apvStsCd", $$c)
                            }
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "ch3" } }, [
                        _c("span"),
                        _vm._v(_vm._s(_vm.$t("msg.SPEC030.004"))),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "content_box mt10" }, [
        _c("div", { staticClass: "flex_box" }, [
          _c("span", { staticClass: "tot_num" }, [
            _vm._v("Total : "),
            _c("span", { staticClass: "num" }, [
              _vm._v(_vm._s(_vm.gridList.length)),
            ]),
          ]),
          _c("span", { staticClass: "input_box" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.templateStr,
                  expression: "templateStr",
                },
              ],
              staticClass: "wid300",
              attrs: {
                type: "text",
                placeholder: _vm.$t("msg.SPEC010G010.000"),
              },
              domProps: { value: _vm.templateStr },
              on: {
                keyup: _vm.templateEnter,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.templateStr = $event.target.value
                },
              },
            }),
          ]),
          _c("span", { staticClass: "ml_auto cal_btn" }, [
            _c(
              "a",
              {
                staticClass: "button sm",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.exlDownload()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("msg.MYIN020T010.016")))]
            ),
          ]),
        ]),
        _c("div", {
          staticStyle: { width: "100%", height: "450px" },
          attrs: { id: "realgrid" },
        }),
      ]),
      _c("div", { staticClass: "flex_box mt10" }, [
        _c(
          "a",
          {
            staticClass: "button lg",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.openPopup("DangerQstDtlPop")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("msg.SPEC030.045")))]
        ),
        _c(
          "a",
          {
            staticClass: "button blue lg ml_auto mr5",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.openPopup("UnnoSearchPop")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("common.UNNO_SEARCH.001")))]
        ),
        _c(
          "a",
          {
            staticClass: "button blue lg mr5",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.openPopup("DangerShipQstPop")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("msg.SPEC030.046")))]
        ),
      ]),
      _c("br"),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.memberDetail.userCtrCd === "KR",
              expression: "memberDetail.userCtrCd === 'KR'",
            },
          ],
          staticClass: "desc_list",
          staticStyle: { "margin-top": "20px" },
        },
        [_vm._m(1)]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "70px" } }),
      _c("col", { attrs: { width: "152px" } }),
      _c("col", { attrs: { width: "*" } }),
      _c("col", { attrs: { width: "100px" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", { staticClass: "font_medium" }, [_vm._v("[ 주의사항 ]")]),
      _c("li", [
        _vm._v(
          " 위험물 분류는 아래 IMDG Code 규정에 따라 화주측 또는 IMDG Code에서 정한 주무관청이 행하여야하며,선사에서는 화주측에서 제공해주신 Class/ UNNO/ Packing 등의 정보를 바탕으로 당사 선박에 선적 가능 여부를 판단합니다. 아래 규정에 따라 실화주측 또는 IMDG Code에서 정한 주무 관청 (대한민국 : 한국해사위험물 검사원)을 통하여 안내받으신 대로 진행하시기 바랍니다. "
        ),
      ]),
      _vm._v(" "),
      _c("br"),
      _c("li", [_vm._v("※ 한국해사 위험물 검사원")]),
      _c("li", [_vm._v(" 1) Web site : http://www.komdi.or.kr/")]),
      _c("li", [
        _vm._v("- Web ->고객지원 -> Q&A 게시판을 통한 위험물 여부 문의 가능."),
      ]),
      _vm._v(" "),
      _c("br"),
      _c("li", [_vm._v("<참고>")]),
      _c("li", [_vm._v("IMDG Code 2장 (책임 ) Responsibilities")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }